import eventBus from 'toxilibs/event_bus_queued.js'
import userProgression from './user_progression.js'

let totalErrors = 0
let currentLevelErrors = 0


eventBus.on('level won', function (levelID) {
    saveEvent('level won', {
        level: levelID,
        errors: currentLevelErrors
    })
    currentLevelErrors = 0
})

eventBus.on('end', function () {
    saveEvent('game end', {
        errors: totalErrors
    })
})

eventBus.on('challenge answer given', saveAnswerEvent)


function saveEvent (eventName, params) {
    params.eventName = eventName

    userProgression.addEvent(params)
}


function saveAnswerEvent (challenge, userAnswer, status) {
    let eventName
    if (status === 'win') {
        eventName = 'right_answer'
    } else if (status === 'lose') {
        eventName = 'wrong_answer'
        currentLevelErrors++
        totalErrors++
    } else {
        eventName = 'too_late'
    }

    saveEvent(eventName, {
        level: challenge.levelID,
        question: questionNumber(challenge.fullLabel),
        duration: Math.round(challenge.totalTime / 100) / 10,
        answer: userAnswer
    })
}


function questionNumber (fullLabel) {
    const splitted = fullLabel.split('_')
    return parseInt(splitted[splitted.length - 1], 10)
}

